import { Box, Button, Card, Paper, Stack, Typography } from '@mui/material';
import intl from 'components/i18n/ReactIntlWrapper';
import { ArrowBack } from '@mui/icons-material';
import { LOGOS } from 'theme/core';

type ErrorTemplateFoundPageProps = {
  statusCode?: number;
  title: string;
  message?: string;
};

export default function ErrorTemplateFoundPage({
  statusCode,
  title,
  message,
}: ErrorTemplateFoundPageProps) {
  return (
    <Box sx={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Stack justifyContent={'center'} alignItems="center" spacing={2} >
        <img src={LOGOS.ISOTYPE.src} width={LOGOS.ISOTYPE.width || 300} style={{opacity: .5}} />
        {statusCode ? (
        <Typography variant="h1">
            {statusCode}
        </Typography>
        ) : (
        <Typography
            color={'error'}
            className="text-center"
            sx={{ fontSize: '3rem', fontWeight: 'bold', whiteSpace: 'nowrap' }}
        >
            Unknow Error
        </Typography>
        )}
        <Typography className="text-center" variant="h2">
          {title}
        </Typography>
        {message && (
          <Typography className="text-center" variant="body1">
            {message}
          </Typography>
        )}
        <Button variant="text" href="/" color="primary">
          <ArrowBack />
          {intl.get('errorPage.back')}
        </Button>
      </Stack>
    </Box>
  );
}
